// src/App.js
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { ApiProvider } from './services/api';

// Pages
import Dashboard from './pages/Dashboard';
import LandingPage from './pages/LandingPage';
import BetaInvite from './pages/BetaInvite';
import Login from './pages/Login';
import Signup from './pages/Signup';
import ForgotPassword from './pages/ForgotPassword';
import Logout from './pages/Logout';
import Account from './pages/Account';
import Contact from './pages/Contact';
// import Subscriptions from './pages/Subscriptions'; // Removed - functionality moved to Dashboard
import SubscriptionDetail from './pages/SubscriptionDetail';
import Transactions from './pages/Transactions';
import Deliveries from './pages/Deliveries';

// Components
import Layout from './components/common/Layout';
import ProtectedRoute from './components/common/ProtectedRoute';

// Admin Components
import { AdminAuthProvider, AdminProtectedRoute } from './components/admin/AdminAuth';
import AdminRouter from './components/admin/AdminLayout';

// Styles
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './bootstrap-custom.css';
import { useSupabase } from './supabaseAuth';

// Root shell. Signed-in users get the normal app chrome (navbar + Outlet, which
// renders the dashboard). Signed-out visitors get the standalone beta request
// page instead: the product is invite only, and the beta page brings its own
// header and footer, so wrapping it in Layout would double up the branding.
// The full marketing site is still reachable at "/landing", inside Layout.
const RootShell = () => {
  const { isAuthenticated } = useSupabase();
  return isAuthenticated ? <Layout /> : <BetaInvite />;
};

const App = () => {
  return (
    <ApiProvider>
      <AdminAuthProvider>
        <Routes>
          <Route path="/login" element={<Layout />}>
            <Route index element={<Login />} />
          </Route>
          <Route path="/signup" element={<Layout />}>
            <Route index element={<Signup />} />
          </Route>
          <Route path="/forgot-password" element={<Layout />}>
            <Route index element={<ForgotPassword />} />
          </Route>
          <Route path="/logout" element={<Logout />} />
          
          {/* Admin Routes with proper sub-routing */}
          <Route 
            path="/midas/*" 
            element={
              <AdminProtectedRoute>
                <AdminRouter />
              </AdminProtectedRoute>
            } 
          />
          
          {/* Full marketing site, still public. Declared before "/" so it wins
              the match and keeps the app chrome. */}
          <Route path="/landing" element={<Layout />}>
            <Route index element={<LandingPage />} />
          </Route>

          {/* Home Route - standalone beta invite for logged out, Dashboard for logged in */}
          <Route path="/" element={<RootShell />}>
            <Route index element={<Dashboard />} />
          </Route>
          
          {/* Protected User Routes */}
          <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
            <Route path="account" element={<Account />} />
            <Route path="contact" element={<Contact />} />
            {/* <Route path="subscriptions" element={<Subscriptions />} /> */}
            <Route path="subscriptions/:id" element={<SubscriptionDetail />} />
            <Route path="transactions" element={<Transactions />} />
            <Route path="deliveries" element={<Deliveries />} />
          </Route>
        </Routes>
      </AdminAuthProvider>
    </ApiProvider>
  );
};

export default App;
